import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class ModulePartService extends BaseService{
	constructor() {
		super('/ModulePart');
	}

	//public updateTenantLock(id:number, isLock: boolean) {
	//	return super.updateBase(this._resourceName + '/lock/' + id +'/'+  isLock,null);
	//}

	public getAllByFilter(filter: ModulePartFilter) {
		return super.getAllByFilterBase(filter);
	}

	public updateModulePartTenant(idTenant: number, eventRole: any) {
		return super.updateBase(this._resourceName + '/update-modulepart/' + idTenant, eventRole);
	}
}

export class ModulePartFilter extends BaseFilter {
	constructor(idTenant?: number | null, idUser?: number | null, showInMenu?: boolean | null) {
		super();
		this._idTenant = idTenant;
		this._idUser = idUser;
		this._showInMenu = showInMenu;
	}

	private _idTenant?: number | null;
	private _idUser?: number | null;
	private _showInMenu?: boolean | null;

	public getAllParams(): {} {

		let data = Object.assign({},
			(this._idTenant != null ? { IdTenant: this._idTenant } : {}),
			(this._idUser != null ? { IdUser: this._idUser } : {}),
			(this._showInMenu != null ? { ShowInMenu: this._showInMenu } : {})
		);

		return data;
	};
}